<script>
export default {
  name: 'SceneGroup',
  data() {
    return {
      isTitleClicked: false,
    }
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },
  render(h) {
    const { options, name, showLabel } = this
    return (
      <div class={'sliderInput SceneGroup'}>
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <div>
          <div
            class={this.isTitleClicked ? 'arrow-down-only' : ''}
            onClick={() => {
              this.isTitleClicked = !this.isTitleClicked
            }}
          >
            {this.isTitleClicked ? <i class="el-icon-arrow-up" /> : <i class="el-icon-arrow-down" />}
          </div>
          {this.isTitleClicked && (
            <div class="area_group_box_tab">
              {options.map((item, index) => {
                return (
                  <div
                    key={index}
                    class="active_btn"
                    onClick={() => {
                      this.$emit('change', item.SceneId)
                    }}
                  >
                    {item.Name}
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  },
}
</script>
<style lang="scss" scoped>
@import '~@/components/button/comps-button.scss';
.area_group_box_tab {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  .active_btn {
    width: 122px;
    height: 30px;
    padding-left: 4px;
    line-height: 30px;
    text-align: left;
    color: #fff;
    margin-right: 10px;
    margin-bottom: 4px;
    background-color: #619ef1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
}
.SceneGroup {
  align-items: flex-start;
}
</style>
